import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TpETLObjectTypes } from '../../etl-data-types/interfaces';
import { TpETLComponentTypeManifest } from '../interfaces';
import { TpETLPipelineComponent, TpETLDryRun, TpETLDryRunComponentResult } from '../../interfaces';
import { copyETLDryRunObjectTableColumns, ETLDryRunObjectTableAddColumnFromParam } from '../utils';
import { addDryRunObjectTable, getETLComponentInputObjectTable } from '../../utils';
import { CONFIGPARAMTYPES } from '../../../visual-analytics/helpers/configParams';
import { VALTYPES } from '../../../../data/interfaces';
import { createConfigParamTypeNewColumn } from '../utils';

function performDryRun(dryRun: TpETLDryRun, comp: TpETLPipelineComponent): TpETLDryRunComponentResult {
  const inputTableObj = getETLComponentInputObjectTable(dryRun, comp, 'sourceTable');
  const outputTableObj = addDryRunObjectTable(dryRun, comp.outputObjectIds['result'], comp);
  // getETLComponentInputObject(dryRun, comp, )
  copyETLDryRunObjectTableColumns(inputTableObj, outputTableObj);
  ETLDryRunObjectTableAddColumnFromParam(outputTableObj, comp, 'response');
  return {
    abort: false,
  };
}

export const manifestETLApplyLLMTable: TpETLComponentTypeManifest = {
  id: 'ApplyLLMTable',
  name: 'Apply LLM on Table',
  description: 'Apply an LLM for each record in a table',
  categoryId: 'llm',
  icon: <FontAwesomeIcon icon={['fas', 'microchip-ai']} />,
  inputs: [
    {
      type: TpETLObjectTypes.TABLE,
      id: 'sourceTable',
      name: 'Source Table',
      columns: [],
    },
  ],
  outputs: [
    {
      id: 'result',
      name: 'Result table',
      type: TpETLObjectTypes.TABLE,
      description: 'Table with the LLM responses',
      columns: [],
    },
  ],
  params: [
    {
      id: 'prompt',
      name: 'Prompt',
      description:
        'Prompt to present to the LLM. You can use {columnIdentifier} as placeholders to use column values in the prompt.',
      paramType: { configParamTypeId: CONFIGPARAMTYPES.Text },
    },
    {
      id: 'jsonSchema',
      name: 'JSON schema',
      description: 'Optionally provides a JSON schema in order to enforce a structured output.',
      paramType: { configParamTypeId: CONFIGPARAMTYPES.Text },
    },
    {
      id: 'response',
      name: 'Response column',
      description: 'New column holding the response of the LLM',
      paramType: createConfigParamTypeNewColumn(VALTYPES.TEXT),
    },
  ],
  performDryRun,
};
